module.exports = __webpack_public_path__ + "media/images/rectangle-16@2x-2315f64e8711b12e455ec0279ac0f27a.png";